import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "./useAuth"
import { STORE_KEY_REDIRECT, PASSPORT_URL, isNH, TokenKey, NHTokenKey } from "@/constants/config"

function RequireAuth({ children }: { children: JSX.Element }) {
  const auth = useAuth()
  const location = useLocation()

  // 农行环境
  if (isNH) {
    if (!auth?.user?.[NHTokenKey]) {
      window.location.href = PASSPORT_URL
      return null
    }
  } else {
    if (!auth?.user?.[TokenKey]) {
      // 存储最后的pathname
      sessionStorage.setItem(STORE_KEY_REDIRECT, location.pathname)
      return <Navigate to="/passport/logout" state={{ from: location.pathname }} replace />
    }
  }

  return children
}

export default RequireAuth
